module.exports = __webpack_public_path__ + "assets/img/timeLine_img18.cfc65162.png";